import { updatesData } from '@/mocks/homeData';

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-16 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            追剧快讯
          </h2>
          <p className="mt-2 text-sm text-foreground-500">
            实时掌握最新上架与更新动态
          </p>
        </div>

        <div className="relative">
          <div className="absolute left-[19px] top-2 bottom-2 w-0.5 bg-background-300"></div>

          <div className="space-y-6">
            {updatesData.map((item, index) => (
              <div key={index} className="relative flex items-start gap-5 pl-12">
                <div className={`absolute left-[15px] top-2 w-[10px] h-[10px] rounded-full border-2 flex-shrink-0 ${
                  index === 0
                    ? 'bg-primary-500 border-primary-500'
                    : 'bg-background-100 border-background-300'
                }`}></div>

                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 flex-wrap">
                    <span className="text-xs text-foreground-400 whitespace-nowrap">
                      {item.time}
                    </span>
                    <span className={`text-xs px-2 py-0.5 rounded-full font-medium whitespace-nowrap ${
                      item.tag === '最新' || item.tag === '热门'
                        ? 'bg-primary-100 text-primary-700'
                        : item.tag === '上新' || item.tag === '独家'
                        ? 'bg-accent-100 text-accent-700'
                        : 'bg-secondary-100 text-secondary-700'
                    }`}>
                      {item.tag}
                    </span>
                  </div>
                  <p className="mt-1 text-sm text-foreground-700 leading-relaxed">
                    {item.title}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}